import { HStack, VStack, IconButton } from "@chakra-ui/react";
import CDS from "design-system";
import { FiMessageSquare } from "react-icons/fi";
import { BasicUser } from "features/User/models";

interface SupportPersonCardProps {
  person: BasicUser;
  jobRole: string;
  showDivider?: boolean;
}

export default function SupportPersonCard({ person, jobRole }: SupportPersonCardProps) {
  const handleSlackMessage = () => {
    if (person.slackUrl) {
      // Open Slack profile in browser
      window.open(person.slackUrl, "_blank");
    }
  };

  return (
    <HStack justify="space-between" align="center" spacing={4}>
      <VStack align="start" spacing={0}>
        <CDS.Text12 color="content.tertiary">
          {jobRole}
        </CDS.Text12>
        <CDS.Text14 fontWeight="semibold" color="content.primary">
          {person.fullName}
        </CDS.Text14>
      </VStack>
      {person.slackUrl && (
        <IconButton
          aria-label={`Message ${person.fullName}`}
          icon={<FiMessageSquare size={20} />}
          variant="ghost"
          color="brand.500"
          onClick={handleSlackMessage}
          _hover={{ bg: "gray.100" }}
        />
      )}
    </HStack>
  );
}
